import script from "./CommonTip.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonTip.vue?vue&type=script&setup=true&lang=js"

import "./CommonTip.vue?vue&type=style&index=0&id=ad25cdc2&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad25cdc2"]])

export default __exports__